export enum ImageSize {
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
}
